export enum CruiseStatus {
  UPCOMING = "upcoming",
  ONGOING = "ongoing",
  ENDED = "ended"
}